import { Button, Checkbox, Form, message } from "antd";
import * as TEACHER_SERVICES from "api/services/teacher/teacher.services";
import FadeInOnScroll from "components/FadeIn";
import FadeInUpOnScroll from "components/FadeInUp";
import { FC, useState } from "react";
import elipse_teachers from "../../../../assets/images/app/home/elipse_teachers.svg";
import elipse_valeur from "../../../../assets/images/app/home/elipse_valeur.svg";
import ellipse_mission from "../../../../assets/images/app/home/ellipse_mission.svg";
import student_contact from "../../../../assets/images/app/home/student_contact.png";
import trace_contact from "../../../../assets/images/app/home/trace_contact.svg";
import contactus_organisme from "../../../../assets/images/app/organisme/contactus_organisme.png";
import contactus_teacher from "../../../../assets/images/app/teachers/contactus_teacher.png";
import s from "./style.module.css";

type Props = {
    from: string;
};

const ContactUs: FC<Props> = ({ from }) => {

    const [form] = Form.useForm();
    const [loading, setLoading] = useState<boolean>(false);

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
    const handleResize = () => {
        setIsMobile(window.innerWidth <= 767);
    };
    window.addEventListener('resize', handleResize);

    const handleFormSubmit = async (values: any) => {
        if (!values?.firstname || !values?.lastname || !values?.email || !values?.phone || !values?.message) {
            message.warning("Merci de renseigner les champs !");
            return;
        }

        try {
            setLoading(true);
            const response = await TEACHER_SERVICES.sendContactMessage(values?.firstname, values?.lastname, values?.email, values?.phone, values?.message);
            if (response?.message === "Workflow was started") {
                message.success("Message envoyé avec succès");
            }
        } catch (error) { }
        finally {
            setLoading(false);
            form.resetFields();
        }
    };

    return (
        <div className={s.mainContainer}>
            <div className={s.contactContainer}>
                <FadeInUpOnScroll>
                    <h1 className={s.contactTitle}>Contactez-nous</h1>
                </FadeInUpOnScroll>
                <img src={ellipse_mission} className={s.ellipseTitle}></img>
                <FadeInOnScroll>
                    <p className={s.contactSubtitle}>Nous sommes à l’écoute!</p>
                </FadeInOnScroll>
                <div className={s.contactBox}>
                    <div className={s.contactMain}>
                        <div className={s.formBox}>
                            <Form form={form} onFinish={handleFormSubmit} style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "flex-start" }}>
                                {!isMobile && <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                                    <div style={{ textAlign: "left" }}>
                                        <label htmlFor="firstname">Nom *</label>
                                        <Form.Item name="firstname">
                                            <input className={s.nameInput} type="text" id="firstname" name="firstname" required></input>
                                        </Form.Item>
                                    </div>
                                    <div style={{ textAlign: "left", marginLeft: "44px" }}>
                                        <label htmlFor="lastname">Prénom *</label>
                                        <Form.Item name="lastname">
                                            <input className={s.lastnameInput} type="text" id="lastname" name="lastname" required></input>
                                        </Form.Item>
                                    </div>
                                </div>}

                                {isMobile && <div className={s.inputDiv}>
                                    <label htmlFor="firstname">Nom *</label>
                                    <Form.Item name="firstname">
                                        <input className={s.nameInput} type="text" id="firstname" name="firstname" required></input>
                                    </Form.Item>
                                </div>}

                                {isMobile && <div className={s.inputDiv}>
                                    <label htmlFor="lastname">Prénom *</label>
                                    <Form.Item name="lastname">
                                        <input className={s.lastnameInput} type="text" id="lastname" name="lastname" required></input>
                                    </Form.Item>
                                </div>}

                                <div className={s.inputDiv}>
                                    <label htmlFor="email">Adresse email *</label>
                                    <Form.Item name="email">
                                        <input className={s.emailInput} type="email" id="email" name="email" required></input>
                                    </Form.Item>
                                </div>
                                <div className={s.inputDiv}>
                                    <label htmlFor="phone">Numéro de téléphone</label>
                                    <Form.Item name="phone">
                                        <input className={s.phoneInput} type="tel" id="phone" name="phone" pattern="^\+?[0-9]{8,15}$"></input>
                                    </Form.Item>
                                </div>
                                <div className={s.inputDiv} style={{ color: "rgb(47, 47, 47)" }}>
                                    <label htmlFor="message">Message</label>
                                    <Form.Item name="message">
                                        <textarea className={s.textareaInput} id="message" name="message" required></textarea>
                                    </Form.Item>
                                </div>
                                <div className={s.checkboxTitle}>
                                    <Checkbox className={s.checkboxStyle}>
                                        {" "}
                                        J’ai lu et j’accepte la <a href="/assets/files/politique-confidentialite.pdf" target="_blank" rel="noopener noreferrer">politique de confidentialité</a> ainsi que<br />les <a href="/assets/files/conditions-generales.pdf" target="_blank" rel="noopener noreferrer">Conditions Générales</a>.
                                    </Checkbox>
                                </div>
                                <Button htmlType="submit" loading={loading} className={s.submitButton}>Envoyer</Button>
                            </Form>
                        </div>
                        {!isMobile && <img src={elipse_teachers} style={{ height: "20px", position: "relative", left: "12%", top: "50px" }}></img>}
                        {!isMobile && <img src={elipse_valeur} style={{ width: "15px", position: "relative", left: "52%", top: "-30%" }}></img>}
                        {!isMobile && <img src={from === "teacher" ? contactus_teacher : from === "landing" ? student_contact : from === "parent" ? contactus_organisme : contactus_organisme} style={{ height: "881px", position: "relative", right: "0%", top: "-50px", zIndex: "0" }}></img>}
                        {!isMobile && <img src={trace_contact} style={{ height: "805px", position: "relative", right: "47%", top: "40%", zIndex: "-1" }}></img>}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactUs;